import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';

export default function PhotoSamplePopup({ show, onClose }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="photo-sample-popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="photo-sample-popup"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="photo-sample-popup-header">
              <h3 className="photo-sample-popup-title">샘플 이미지</h3>
              <button className="photo-sample-popup-close" onClick={onClose}>
                <Icon icon="solar:close-circle-bold" width={20} height={20} />
              </button>
            </div>
            <div className="photo-sample-popup-content">
              <p className="photo-sample-popup-description">각 스타일의 샘플 이미지를 확인하세요</p>
              <div className="photo-sample-grid">
                <div className="photo-sample-item">
                  <div className="photo-sample-label">밈 케이스 1</div>
                  <div className="photo-sample-image-container">
                    <img src="/sample-meme1.png" alt="밈 케이스 1 샘플" className="photo-sample-image" />
                  </div>
                </div>
                <div className="photo-sample-item">
                  <div className="photo-sample-label">밈 케이스 2</div>
                  <div className="photo-sample-image-container">
                    <img src="/sample-meme2.png" alt="밈 케이스 2 샘플" className="photo-sample-image" />
                  </div>
                </div>
                <div className="photo-sample-item">
                  <div className="photo-sample-label">사진 그대로</div>
                  <div className="photo-sample-image-container">
                    <img src="/sample-original.png" alt="사진 그대로 샘플" className="photo-sample-image" />
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}


